module.exports = __webpack_public_path__ + "img/shop.0c89e0f4.png";